"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useGetOlapicStream = void 0;
var _fetching = require("@ori/fetching");
var _presentationHttp = require("@ori/presentation-http");
var _models = require("../models");
var _utils = require("../utils");
var _externalUrl = require("./externalUrl");
/* istanbul ignore file @preserve --api */

const fetchOlapicStream = async ({
  apiKey,
  customerId,
  tag
}) => {
  const {
    apiDomain,
    apiVersion,
    wrapResponses
  } = _externalUrl.baseConfig;
  const url = `${apiDomain}customers/${customerId}/streams/bytag/${tag}?auth_token=${apiKey}&version=${apiVersion}&wrap_responses=${wrapResponses}`;
  return (0, _externalUrl.getExternalUrl)(url, {
    responseType: 'json'
  });
};
const getOlapicStream = async ({
  apiKey,
  customerId,
  tag
}) => {
  const defaultStream = {
    created: Date.now(),
    name: '',
    id: '',
    tag
  };
  const expireTime = (0, _externalUrl.getExpireTime)(_externalUrl.cacheMinutes.streams);
  const localStorageData = (0, _utils.loadFromLocalStorage)(_utils.LocalStorageNames.streams);
  if (localStorageData) {
    const stream = localStorageData.find(item => item.tag === tag && item.created > expireTime);
    if (stream) {
      return {
        local: true,
        stream
      };
    }
  }
  const response = await fetchOlapicStream({
    apiKey,
    customerId,
    tag
  });
  return (0, _presentationHttp.validateResponse)(response, {
    schema: _models.olapicResponseStreamSchema,
    onError: () => ({
      local: true,
      stream: defaultStream
    }),
    onSuccess: ({
      data
    }) => {
      const result = data.data;
      return {
        local: false,
        stream: {
          ...defaultStream,
          name: result.name,
          id: result.id
        }
      };
    }
  });
};
const useGetOlapicStream = ({
  apiKey,
  customerId,
  tag,
  enabled = true
}) => {
  const shouldFetch = Boolean(apiKey && customerId && tag && enabled);
  const {
    data,
    error
  } = (0, _fetching.useSWR)(shouldFetch ? [apiKey, customerId, tag] : null, async () => getOlapicStream({
    apiKey,
    customerId,
    tag
  }), {
    revalidateIfStale: false,
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
    onSuccess: ({
      local,
      stream
    }) => {
      if (local) {
        return;
      }
      const streams = (0, _utils.loadFromLocalStorage)(_utils.LocalStorageNames.streams) ?? [];
      const expireTime = (0, _externalUrl.getExpireTime)(_externalUrl.cacheMinutes.streams);
      const updatedStreams = streams.filter(item => item.created > expireTime);
      updatedStreams.push(stream);
      (0, _utils.saveToLocalStorage)(_utils.LocalStorageNames.streams, updatedStreams);
    }
  });
  return {
    data,
    isLoading: data === undefined && error === undefined,
    isError: Boolean(error)
  };
};
exports.useGetOlapicStream = useGetOlapicStream;
